/**
 * Barrel export file for ChatEditorMention components and utilities.
 *
 * This provides a clean public API for the ChatEditorMention module,
 * allowing consumers to import everything from a single location.
 */

// Mention element (pill display)
export * from './MentionElement';

// Mention utilities and types
export * from './utils';

import { mentionType } from '@aline/common';
import { MentionPlugin } from '@platejs/mention/react';

import { MENTION_TRIGGER_PREVIOUS_CHAR_PATTERN } from './mention-trigger';
import { CHAT_EDITOR_DATA_ATTRS, MentionElement } from './MentionElement';

export const MentionKit = [
  MentionPlugin.configure({
    options: {
      triggerPreviousCharPattern: MENTION_TRIGGER_PREVIOUS_CHAR_PATTERN,
    },
    parsers: {
      html: {
        deserializer: {
          parse: ({ element }) => {
            const documentId = element.getAttribute(CHAT_EDITOR_DATA_ATTRS.documentId);
            const documentName = element.getAttribute(CHAT_EDITOR_DATA_ATTRS.documentName);
            const mentionTypeName = element.getAttribute(CHAT_EDITOR_DATA_ATTRS.mentionTypeName);

            return {
              documentId,
              documentName,
              mentionTypeName,
              type: mentionType,
              value: element.textContent || '',
            };
          },
          rules: [
            {
              validAttribute: CHAT_EDITOR_DATA_ATTRS.slateMention,
            },
          ],
        },
      },
    },
  }).withComponent(MentionElement),
];
